<template>
    <div>
        <div>
            <creator-guide-view />
        </div>
        <b-list-group>
            <b-list-group-item variant="primary">
                <div>
                    <h5
                        class="d-flex align-items-center justify-content-between"
                    >
                        Creator Guide
                    </h5>
                </div>
                <div class="small">
                    Complete the guides below at your own pace to setup your
                    account to start learning how to optimize your account
                </div>
            </b-list-group-item>
            <b-list-group-item
                class="d-flex justify-content-between align-items-center fake-link"
                :key="guide.key"
                v-for="guide in guides"
                action
                @click="setCurrentGuide(guide)"
            >
                <div class="mr-4">
                    <font-awesome-icon
                        v-if="guide.complete"
                        class="text-primary"
                        icon="fa-solid fa-check-circle"
                    />
                    <font-awesome-icon
                        v-else
                        icon="fa-solid fa-circle"
                    ></font-awesome-icon>
                </div>
                <div class="flex-grow-1">
                    <div class="text-dark">
                        {{ guide.title }}
                    </div>
                    <div class="small text-secondary">
                        {{ guide.description }}
                    </div>
                </div>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<script>
import CreatorGuideView from "@/components/creator/guide/CreatorGuideView";

import { mapGetters, mapState } from "vuex";

export default {
    created() {
        this.$store.dispatch("creatorGuide/refresh");
    },
    computed: {
        ...mapState("creatorGuide", ["currentGuide", "guides"]),
        ...mapGetters("creatorGuide", [
            "hasIncompleteGuides",
            "incompleteGuides",
        ]),
    },
    methods: {
        setCurrentGuide(guide) {
            this.$store.dispatch("creatorGuide/setCurrentGuide", guide);
        },
    },
    components: {
        CreatorGuideView,
    },
};
</script>